import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  favoriteButton: {
    '& svg': {
      width: '1.1em',
      height: '1.1em',
      marginBottom: 2,
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      '& svg': {
        transform: 'scale(1.1)',
      },
    },
    '&:disabled, &.Mui-disabled': {
      opacity: 0.4,
      cursor: 'not-allowed',
      '& svg': {
        color: 'rgba(246, 96, 0, 0.4) !important',
      },
      '&:hover': {
        backgroundColor: 'transparent',
        '& svg': {
          transform: 'none',
        },
      },
    },
  },
  favoriteIcon: {
    color: '#f66000',
    fontSize: '24px !important',
    transition: 'color 0.2s ease, transform 0.2s ease',
  },
}));
